<template>
	<CSidebar
		:minimize="minimize"
		unfoldable
		:show="show"
		@update:show="(value) => $store.commit('set', ['sidebarShow', value])"
		colorScheme="warning"
		style="background-color: #233d41"
		class="c-sidebar-unfoldable"
	>
		<CSidebarBrand class="d-md-down-none" style="background-color: #006d40">
			<CImg
				class="c-sidebar-brand-full pr-3"
				:src="logo"
				style="width: 70% !important"
				fluidGrow
			/>
			<!-- <img
                :src="logo"
                class="c-sidebar-brand-full"
                style="width: 12rem;"
            /> -->
			<img
				class="c-sidebar-brand-minimized"
				src="logo.png"
				name="logo"
				:height="35"
				viewBox="0 0 110 134"
			/>
		</CSidebarBrand>

		<!-- <CSidebarNav v-for="item in admin" :key="item.name">
            <li class="c-sidebar-nav-item" data-v-3738b722="">
                <a :href="item.to" target="_self" class="c-sidebar-nav-link">
                    <img :src="item.icon" class="c-sidebar-nav-icon" />
                    Overview
                </a>
            </li>
        </CSidebarNav> -->
		<CRenderFunction flat :contentToRender="getSidebarOnRole" />
		<CSidebarMinimizer
			class="c-d-md-down-none"
			@click.native="$store.commit('toggle', 'sidebarMinimize')"
		/>
	</CSidebar>
</template>

<script>
import { client_user, client_admin, sys_admin, group_admin } from "./_nav";
import { storeData } from "../store";
import gql from "graphql-tag";
import logo from "../assets/images/logo.svg";

const GET_USER_DETAILS = gql`
	query MyQuery {
		spendmd_db_users {
			role_id
			verification_pending
			account_disabled
			is_rejected
			id
			client_id
			password
			name
			id
			role {
				name
			}
			client {
				name
			}
		}
	}
`;

export default {
	name: "TheSidebar",
	client_admin,
	client_user,
	sys_admin,
	group_admin,
	data() {
		return {
			logo,
			count: this.$store.state.userCount,
		};
	},
	computed: {
		show() {
			return this.$store.state.sidebarShow;
		},
		minimize() {
			return this.$route.path.includes("dashboard") ||
				this.$route.path.includes("overview")
				? true
				: this.$store.state.sidebarMinimize;
		},
		getSidebarOnRole() {
			let role = JSON.parse(sessionStorage.getItem("vue-session-key")).role;
			if (role === "sys_admin") return sys_admin;
			else if (role === "group_admin") return group_admin;
			else if (role === "client_admin") return client_admin;
			else if (role === "client_user") return client_user;
			else return null;
			return null;
		},
	},
	methods: {
		reRender() {
			this.$forceUpdate();
		},
	},
	apollo: {
		$subscribe: {
			userData: {
				query: GET_USER_DETAILS,
				result({ data }) {
					storeData.userAuthenticationList = data.spendmd_db_users;
				},
			},
		},
	},
};
</script>

<style>
.c-sidebar {
	overflow: hidden;
}
.c-sidebar:hover .c-sidebar-nav-subitem > a {
    padding-left: 56px;
}
.c-sidebar-nav-subitem > a {
	padding-left: 1rem;
	transition: padding-left .3s ease;
}
</style>